/*@ngInject*/
const UserActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deactivateUser = function (userId) {
        let url = '/rest/User/' + userId + '/deactivate';
        return this.post(url);
    };

    this.activateUser = function (userId) {
        let url = '/rest/User/' + userId + '/activate';
        return this.post(url);
    };

    this.deleteUser = function (userId) {
        let url = '/rest/User/' + userId;
        return this.delete(url);
    };

    this.resetPassword = function (userId) {
        let url = '/rest/User/' + userId + '/resetPassword';
        return this.post(url);
    };

    this.unlockUser = function (userId) {
        let url = '/rest/User/' + userId + '/unlock';
        return this.post(url);
    };

    this.getFormSetId = function (userId) {
        let url = '/rest/User/' + userId + '/formset';
        return this.get(url);
    };
};

angular.module('umCore')
    .service('userActionRepository', UserActionRepository);
